// Time cell — renders the event time, or an occurs_hint label (Pre/Post/N/A).

import type { CalendarEvent, OccursHint } from "../types";
import { formatTime } from "../utils/date";

interface TimeCellProps {
  event: CalendarEvent;
}

export function TimeCell({ event }: TimeCellProps) {
  const hint = (event as { occurs_hint?: OccursHint | null }).occurs_hint;
  if (hint === "all_day") return <>N/A</>;
  if (hint === "pre_market") return <span title="Pre Market">Pre</span>;
  if (hint === "post_market") return <span title="Post Market">Post</span>;
  return <>{formatTime(event.occurs_at)}</>;
}

export default TimeCell;
